import css from '../index.css'
import tippy from '../src/index.ts'
import { injectCSS } from '../src/css'

injectCSS(css)

export default tippy
